<template>
  <div class="track-content-preview">
    <span v-if="!content">—</span>
    <template v-else>
      <div
        ref="clamp"
        class="track-md track-content-clamp"
        v-html="html"
      ></div>
      <a v-if="overflow" href="javascript:;" class="track-content-view" @click.stop="$emit('view')">查看</a>
    </template>
    <slot></slot>
  </div>
</template>

<script>
import { renderSimpleMarkdown } from '@/utils/simpleMarkdown'

export default {
  name: 'TrackContentPreview',
  props: {
    content: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      overflow: false
    }
  },
  computed: {
    html () {
      return renderSimpleMarkdown(this.content)
    }
  },
  watch: {
    content () {
      this.scheduleCheck()
    },
    html () {
      this.scheduleCheck()
    }
  },
  mounted () {
    this.scheduleCheck()
    if (typeof ResizeObserver !== 'undefined') {
      this._ro = new ResizeObserver(() => this.checkOverflow())
      if (this.$el) this._ro.observe(this.$el)
    } else if (typeof window !== 'undefined') {
      this._onResize = () => this.checkOverflow()
      window.addEventListener('resize', this._onResize)
    }
  },
  updated () {
    this.scheduleCheck()
  },
  beforeDestroy () {
    if (this._ro) {
      this._ro.disconnect()
      this._ro = null
    }
    if (this._onResize) {
      window.removeEventListener('resize', this._onResize)
      this._onResize = null
    }
    if (this._timer) {
      clearTimeout(this._timer)
      this._timer = null
    }
  },
  methods: {
    scheduleCheck () {
      this.$nextTick(() => {
        if (this._timer) clearTimeout(this._timer)
        this._timer = setTimeout(() => {
          this._timer = null
          this.checkOverflow()
        }, 0)
      })
    },
    checkOverflow () {
      const el = this.$refs.clamp
      if (!el) {
        this.overflow = false
        return
      }
      // max-height / line-clamp 后 scrollHeight 大于可视高度即溢出
      this.overflow = el.scrollHeight > el.clientHeight + 1
    }
  }
}
</script>

<style scoped>
.track-content-preview {
  text-align: left;
  width: 100%;
}
/* 最多三行；Markdown 可能含块级标签，用 max-height 兜底，line-clamp 做省略 */
.track-content-clamp {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  overflow: hidden;
  word-break: break-word;
  line-height: 1.5;
  font-size: 14px;
  max-height: 4.5em; /* 3 * 1.5 */
}
.track-content-view {
  display: inline-block;
  margin-top: 4px;
}
.track-md /deep/ .md-table { border-collapse: collapse; width: 100%; margin: 4px 0; }
.track-md /deep/ .md-table th, .track-md /deep/ .md-table td { border: 1px solid #e8e8e8; padding: 2px 6px; }
.track-md /deep/ h2, .track-md /deep/ h3, .track-md /deep/ h4 { margin: 6px 0 4px; font-size: 14px; }
.track-md /deep/ ul, .track-md /deep/ ol { padding-left: 18px; margin: 4px 0; }
.track-md /deep/ blockquote { margin: 4px 0; padding-left: 8px; border-left: 3px solid #ddd; color: #666; }
.track-md /deep/ p { margin: 2px 0; }
</style>



// WEBPACK FOOTER //
// TrackContentPreview.vue?59fc8392